<div class="content-block">
  <h2>{{ formatMessage("sidenav.calculations") }}</h2>

  <app-calculations-grid> </app-calculations-grid>
</div>
